import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirSiglaRequest } from './types';

// ACTIONS
import { excluirSiglaSuccess, excluirSiglaFailure } from './actions';

function* excluirSigla(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ExcluirSiglaRequest } = request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`siglas/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirSiglaSuccess(response));
	} else {
		yield put(excluirSiglaFailure());
	}
}

export default all([takeLatest(Types.EXCLUIR_SIGLA_REQUEST, excluirSigla)]);
